import HeaderHero from "../HeaderHero";
import React from "react";
import AboutUs from "../assets/img/aboutus.jpg";
import { Link } from "react-router-dom";

export default function About() {
  const offers = [
    {
      icon: "bi-table",
      title: "Business Data Solutions",
      text: "Quality business data to support lead generation, outreach and business growth.",
    },
    {
      icon: "bi-geo-alt-fill",
      title: "PAN India Business Data",
      text: "Business data covering multiple industries and cities across India.",
    },
    {
      icon: "bi-globe-americas",
      title: "US Business Data",
      text: "Business data for marketing, expansion and international opportunities.",
    },
    {
      icon: "bi-book-half",
      title: "Digital Books (eBooks)",
      text: "Learn business, marketing, finance and entrepreneurship at your own pace.",
    },
    {
      icon: "bi-graph-up-arrow",
      title: "Trading Courses",
      text: "Practical trading courses covering markets, analysis and strategies.",
    },
    {
      icon: "bi-lightbulb-fill",
      title: "Business Growth Solutions",
      text: "Digital resources that help businesses make informed decisions and grow.",
    },
  ];

  const reasons = [
    "Premium Business Data",
    "Instant Digital Access",
    "Secure Purchases",
    "Affordable Pricing",
    "Trusted Resources",
    "Dedicated Support",
  ];

  const trust = [
    "Verified Digital Products",
    "Easy Downloads",
    "Reliable Customer Support",
    "Quality Resources",
    "Secure Payments",
    "Business Focused Solutions",
  ];

  return (
    <>
      <HeaderHero Name={"About Us"} />
      <section className="py-5 mt-5 mb-5">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <span className="section-subtitle">ABOUT DOMEHELP</span>
              <h2 className="section-title mt-3">
                Empowering Businesses Through{" "}
                <span className="text-theme">Digital Solutions</span>
              </h2>
              <p>
                DomeHelp is a trusted digital platform helping entrepreneurs,
                professionals and organizations grow through high-quality
                business data, digital learning resources and business growth
                solutions.
              </p>
              <p>
                From PAN India and US business data to eBooks and trading
                courses, we provide practical digital products that help you
                discover opportunities and grow with confidence.
              </p>
              <Link to="/Products" className="btn btn-theme mt-3">
                Explore Solutions
              </Link>
            </div>
            <div className="col-lg-6 text-center">
              <img src={AboutUs} className="img-fluid" alt="About DomeHelp" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6">
              <div className="about-card h-100">
                <i className="bi bi-bullseye icon"></i>
                <h3>Our Mission</h3>
                <p>
                  To make business data and digital learning accessible,
                  affordable and valuable for businesses worldwide.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-card h-100">
                <i className="bi bi-eye icon"></i>
                <h3>Our Vision</h3>
                <p>
                  To become a trusted destination for business data, digital
                  learning and business growth solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <span className="section-subtitle">OUR SOLUTIONS</span>
            <h2 className="section-title mt-2">What We Offer</h2>
          </div>
          <div className="row g-4">
            {offers.map((o, i) => (
              <div className="col-md-6 col-lg-4" key={i}>
                <div className="offer-card h-100">
                  <i className={`bi ${o.icon} offer-icon`}></i>
                  <h5>{o.title}</h5>
                  <p>{o.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container text-center">
          <span className="section-subtitle">WHY DOMEHELP</span>
          <h2 className="section-title mt-2 mb-5">Why Choose DomeHelp</h2>
          <div className="row g-4">
            {reasons.map((r, i) => (
              <div className="col-md-4" key={i}>
                <div className="reason-card">
                  <i className="bi bi-check-circle-fill text-theme fs-2"></i>
                  <h6 className="mt-3">{r}</h6>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="trust-section py-5">
        <div className="container pt-5 pb-5">
          <div className="text-center text-white">
            <h2 className="fw-bold text-white mb-3">
              Why Customers Trust DomeHelp
            </h2>

            <p className="trust-description">
              We focus on delivering quality digital products and a seamless
              customer experience.
            </p>
          </div>

          <div className="row g-4 mt-5">
            {trust.map((t, i) => (
              <div className="col-md-6 col-lg-4" key={i}>
                <div className="trust-card">
                  <i className="bi bi-shield-check"></i>
                  <span>{t}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="trust-divider"></div>

          <div className="text-center mt-5">
            <h2 className="text-white fw-bold">Ready to Grow Your Business?</h2>

            <p className="text-white-50 mb-4">
              Explore premium business data, eBooks and digital learning
              resources.
            </p>
            <Link to="/Products" className="btn btn-secondary mt-3">
              Explore Solutions
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
